"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundTo = void 0;
function roundTo(n, decimals) {
    return +(n.toFixed(decimals));
}
exports.roundTo = roundTo;
